/**
 * Derives the full redirect URL, swapping the brand domain when needed.
 *
 * - RentMatch brokers  → rentmatch(-internal).be + path
 * - Regular brokers    → mijnhuurprofiel(-internal).be + path
 *
 * The swap is done by replacing the word "mijnhuurprofiel" ↔ "rentmatch"
 * in the current hostname, which works automatically for all environments:
 *   dev.mijnhuurprofiel-internal.be → dev.rentmatch-internal.be
 *   stag.mijnhuurprofiel-internal.be → stag.rentmatch-internal.be
 *   mijnhuurprofiel.be → rentmatch.be
 *
 * On localhost / IP addresses / tunnels no cross-domain swap is done.
 *
 * @param {boolean} isRentMatch - Whether the property belongs to a RentMatch broker
 * @param {string} path - The relative URL path to redirect to (e.g. /property/:id/rentmatch/intro)
 * @returns {{ type: 'relative' | 'absolute', url: string }}
 */
export function buildRedirectTarget(isRentMatch, path) {
  const { hostname, protocol, port } = window.location
  const portStr = port ? `:${port}` : ''

  // Local / IP / tunnel → no cross-domain switch, stay on current origin
  const noSwapDomains = ['trycloudflare.com', 'loca.lt', 'ngrok.io', 'ngrok-free.app']
  const isLocal =
    hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname) || noSwapDomains.some(d => hostname.endsWith(d))

  if (isLocal) {
    return { type: 'relative', url: path }
  }

  // Derive target hostname by swapping the brand name
  const targetHostname = isRentMatch
    ? hostname.replace('mijnhuurprofiel', 'rentmatch')
    : hostname.replace('rentmatch', 'mijnhuurprofiel')

  if (targetHostname === hostname) {
    // Already on the correct domain — no swap needed
    return { type: 'relative', url: path }
  }

  return {
    type: 'absolute',
    url: `${protocol}//${targetHostname}${portStr}${path}`,
  }
}



// WEBPACK FOOTER //
// ./src/utils/domainRedirect.js